


























































































import Vue from "vue";
import Component from "vue-class-component";
import { Emit, Prop, Watch } from "vue-property-decorator";
import moment from "moment-timezone";
import { ChallengeModel, Translated } from "@/models/challenge.model";
import { i18nModule, userModule } from "@/utils/store-acessor";
import { LocaleSelectorType } from "@/store/i18n.store.module";
import { nFormatter } from "@/utils/utils";

@Component({})
export default class ChallengeCard extends Vue {
  @Prop({ required: true }) isMyChallenge!: boolean;
  @Prop({ required: false, default: false }) loading!: boolean;
  @Prop({ required: true })
  challenge!: ChallengeModel;
  @userModule.Getter("timezone") timezone!: string;
  @i18nModule.Getter("locale") locale!: LocaleSelectorType;
  deadline = "";

  isCommingSoonSituation() {
    return this.challenge.situation == "comming_soon";
  }

  get type() {
    return this.challenge.type || "competition";
  }

  @Emit()
  openChallenge(slug: string) {
    this.$router.push(`/challenges/${slug}`);
  }

  get challengeTitle(): string {
    const locale = this.locale.value;
    const title = this.challenge?.title as Translated;
    if (!!title) {
      switch (locale) {
        case "en":
          // @ts-ignore
          return title.en || title;
        case "ptBr":
          // @ts-ignore
          return title.pt || title;
      }
    }
    return "";
  }

  get challengeShortDescription(): string {
    const locale = this.locale.value;
    const short_description = this.challenge?.short_description as Translated;
    if (!!short_description) {
      switch (locale) {
        case "en":
          // @ts-ignore
          return short_description.en || short_description;
        case "ptBr":
          // @ts-ignore
          return short_description.pt || short_description;
      }
    }
    return "";
  }

  @Watch("locale", { deep: true, immediate: true })
  onLocaleChange(locale: LocaleSelectorType) {
    if (this.challenge?.deadline) {
      const days: number = moment(this.challenge.deadline)
        .tz(this.timezone)
        .diff(moment(), "days");
      if (days > 0) {
        const plural = days < 2 ? 1 : 2;
        this.deadline = this.$tc("challenge.ending_in_days", plural, [days]).toString();
      } else {
        this.deadline = this.$t("challenge.challenge_ended").toString();
      }
    } else {
      this.deadline = this.$t("challenge.never_end").toString();
    }
  }

  formatCounter(value: number) {
    return nFormatter(value);
  }
}
